import { SvgIcon, SvgIconProps } from '@mui/material';

const IntroductionIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.5 13.6h6.3v-1.2h-5.1l-1.2 1.2Zm-3.3 0h1.58l5.04-4.98c.08-.08.12-.18.12-.3s-.04-.22-.12-.3l-1.1-1a.34.34 0 0 0-.25-.1.34.34 0 0 0-.25.1l-5.02 5.1v1.48ZM4 20V5.2c0-.307.12-.583.36-.83S4.88 4 5.2 4h13.6c.307 0 .583.123.83.37s.37.523.37.83v10.4c0 .307-.123.583-.37.83s-.523.37-.83.37H7.2L4 20Zm1.2-2.9 1.5-1.5h12.1V5.2H5.2v11.9Zm0-11.9v11.9V5.2Z"
    />
  </SvgIcon>
);

export default IntroductionIcon;
